import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {FileNameSetService} from "../services/file-name-set.service";

@Injectable()
export class FileNameInterceptor implements HttpInterceptor {

  constructor(
    private fileNameSetService: FileNameSetService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const request = req.clone();

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse)
            if (event.headers.has('Content-Disposition')) {
              const headerFileName = event.headers.get('Content-Disposition') ?? ''
              this.fileNameSetService.fileName$.next(headerFileName)
            }
        }
      )
    );
  }

}
